import { ENV } from "./env";

// ルール:
// フィーチャーフラグの使用箇所を明確にするため、機能名やそれに準ずる命名をフラグ名として使用する

const EnvName = {
  Local: "local",
  DevelopInno: "inno-dev",
  Development: "development-new",
  Staging: "staging-new", // NOTE: stg は本番と同等の環境として扱いたいので、基本的に有効状態のままにはしないこと
};

export const isWakeLockEnabled = () => {
  return [EnvName.Local, EnvName.Development].includes(ENV);
};

// https://www.notion.so/119e6cf8d068806a9a0be02bebf4b994
export const isLanguageSwitcherEnabled = () => {
  return [EnvName.Local, EnvName.Development].includes(ENV);
};

export const isConsultationMenuItem2Enabled = () => {
  return [EnvName.Local, EnvName.Development].includes(ENV);
};

// 予約時の医師選択プルダウン表示可否
export const isSelectDoctorVisibleEnabled = () => {
  return [EnvName.Local, EnvName.Development].includes(ENV);
};

/**
 * @description インバウンド患者のフラグ
 */
export const isInboundEnabled = () => {
  return [EnvName.Local, EnvName.Development].includes(ENV);
};

/**
 * @description オンライン資格確認モックページの有効フラグ
 * prd/stg は外部接続があるため無効
 */
export const isMyNumberMockEnabled = () => {
  return [EnvName.Local, EnvName.DevelopInno, EnvName.Development].includes(
    ENV
  );
};
